import React from "react";
import { CredentialProps } from "../CredentialProps";
import { CredentialLayout } from '../CredentialLayout';
import { CredentialEntities } from "../CredentialEntities";
import { NSARouterMakerProps } from "namirasoft-account-react";

interface AzureListPageProps extends NSARouterMakerProps, CredentialProps { }

export default class AzureListPage extends React.Component<AzureListPageProps>
{
	override render()
	{
		return (
			<CredentialLayout
				{...this.props}
				action={{
					title: "",
					description: "Azures for adding a job to your list, such as matching skills or salary, that are default or added by you. Azures are assinged to statuses.",
					menus: {}
				}}
				pages={{
					entity: CredentialEntities.azure(this.props),
					list: {
						ui: {}
					}
				}}
			>
				<></>

			</CredentialLayout >
		);
	}
}